// import all images from assets/images directory
import img01 from "../all-images/cars-img/prado.png";
import img02 from "../all-images/cars-img/alphard.png";
import img03 from "../all-images/cars-img/demio.png";
import img04 from "../all-images/cars-img/note.png";
import img05 from "../all-images/cars-img/vitz.png";
import img06 from "../all-images/cars-img/premio.png";
import img07 from "../all-images/cars-img/axio.png";
import img08 from "../all-images/cars-img/fielder.png";
import img09 from "../all-images/cars-img/axela.png";
import img010 from "../all-images/cars-img/wish.png";
import img011 from "../all-images/cars-img/markx.png";
import img012 from "../all-images/cars-img/juke.png";
import img013 from "../all-images/cars-img/noah.png";
import img014 from "../all-images/cars-img/voxy.png";
import img015 from "../all-images/cars-img/cx5.png";
import img016 from "../all-images/cars-img/serena.png";
import img017 from "../all-images/cars-img/vanguard.png";
import img018 from "../all-images/cars-img/harrier.png";
import img019 from "../all-images/cars-img/pradoj120.png";
import img020 from "../all-images/cars-img/xtrail.png";
import img021 from "../all-images/cars-img/harrierOld.png";
import img022 from "../all-images/cars-img/harrierNew.png";
import img023 from "../all-images/cars-img/crv.png";
import img024 from "../all-images/cars-img/atenza.png";
import img025 from "../all-images/cars-img/rav4.png";



const carData = [
  {
    id: 1,
    brand: "Toyota",
    rating: 112,
    carName: "Toyota Prado J150",
    imgUrl: img01,
    model: "Model 3",
    price: 13000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description: "",
  },

  {
    id: 2,
    brand: "Toyota",
    rating: 102,
    carName: "Toyota Alphard",
    imgUrl: img02,
    model: "Model-2022",
    price: 7000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },

  {
    id: 3,
    brand: "Mazda",
    rating: 132,
    carName: "Mazda Demio",
    imgUrl: img03,
    model: "Model-2022",
    price: 3000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },

  {
    id: 4,
    brand: "Nissan",
    rating: 102,
    carName: "Nissan Note",
    imgUrl: img04,
    model: "Model-2022",
    price: 3000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },

  {
    id: 5,
    brand: "Toyota",
    rating: 94,
    carName: "Toyota Vitz",
    imgUrl: img05,
    model: "Model-2022",
    price: 3000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },

  {
    id: 6,
    brand: "Toyota",
    rating: 119,
    carName: "Toyota Premio",
    imgUrl: img06,
    model: "Model-2022",
    price: 4000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },

  {
    id: 7,
    brand: "Toyota",
    rating: 82,
    carName: "Toyota Axio",
    imgUrl: img07,
    model: "Model 3",
    price: 3500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },

  {
    id: 8,
    brand: "Toyota",
    rating: 52,
    carName: "Toyota Fielder",
    imgUrl: img08,
    model: "Model 3",
    price: 3500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 9,
    brand: "Mazda",
    rating: 132,
    carName: "Mazda Axela",
    imgUrl: img09,
    model: "Model-2022",
    price: 3500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 10,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Wish",
    imgUrl: img010,
    model: "Model-2022",
    price: 4000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 11,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Mark X",
    imgUrl: img011,
    model: "Model-2022",
    price: 4500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 12,
    brand: "Nissan",
    rating: 132,
    carName: "Nissan Juke",
    imgUrl: img012,
    model: "Model-2022",
    price: 4000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 13,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Noah",
    imgUrl: img013,
    model: "Model-2022",
    price: 6000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 14,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Voxy",
    imgUrl: img014,
    model: "Model-2022",
    price: 6000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 15,
    brand: "Mazda",
    rating: 132,
    carName: "Mazda CX5",
    imgUrl: img015,
    model: "Model-2022",
    price: 7000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 16,
    brand: "Nissan",
    rating: 132,
    carName: "Nissan Serena",
    imgUrl: img016,
    model: "Model-2022",
    price: 6000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 17,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Vanguard",
    imgUrl: img017,
    model: "Model-2022",
    price: 7000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 18,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Harrier",
    imgUrl: img018,
    model: "Model-2022",
    price: 7000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 19,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Prado J120",
    imgUrl: img019,
    model: "Model-2022",
    price: 12000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 19,
    brand: "Nissan",
    rating: 132,
    carName: "Nissan Xtrail",
    imgUrl: img020,
    model: "Model-2022",
    price: 6500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 19,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Harrier",
    imgUrl: img021,
    model: "Model-2022",
    price: 6500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 19,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota Harrier (New)",
    imgUrl: img022,
    model: "Model-2022",
    price: 8000,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 19,
    brand: "Honda",
    rating: 132,
    carName: "Honda CRV",
    imgUrl: img023,
    model: "Model-2022",
    price: 6500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 19,
    brand: "Mazda",
    rating: 132,
    carName: "Atenza",
    imgUrl: img024,
    model: "Model-2022",
    price: 4500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
  {
    id: 19,
    brand: "Toyota",
    rating: 132,
    carName: "Toyota RAV4",
    imgUrl: img025,
    model: "Model-2022",
    price: 6500,
    speed: "20kmpl",
    gps: "GPS Navigation",
    seatType: "Heated seats",
    automatic: "Automatic",
    description:
      " Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam. Dolor labore lorem no accusam sit justo sadipscing labore invidunt voluptua, amet duo et gubergren vero gubergren dolor. At diam.",
  },
];

carData.forEach((car) => {
  car.description = `Explore the unmatched comfort and performance of our ${car.carName}, available at just Ksh ${car.price} per day. With a stellar rating of ${car.rating}, this versatile vehicle promises a memorable journey every time. Its transmission ensures a smooth ride, making it the ideal choice for any adventure. At Sankhu Car Rentals and Tours, our commitment to excellence extends to every vehicle we offer. Please note that our minimum rental period is 2 days. We prioritize your safety and comfort, ensuring your rental experience exceeds expectations. Book your ${car.carName} today and embark on a seamless and enjoyable drive.`;
});

export default carData;
